import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import * as qs from 'query-string';
import { Pagination } from '@cvent/carina/components/Pagination';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';

const styles = require('./pagination.scss');

type IPaginationProps = {
    itemsCount: number;
};

export const SRP_RESULT_PER_PAGE = 36;

export const PaginationComponent = ({ itemsCount }: IPaginationProps) => {
    const history = useHistory();

    const search = qs.parse(useLocation().search);
    const current = parseInt(search.page as string, 10) || 1;
    const pageCount = Math.floor(itemsCount / SRP_RESULT_PER_PAGE);

    if (pageCount > 0) {
        return (
            <div className={styles.pagination}>
                <Pagination
                    totalPages={pageCount}
                    defaultSelected={1}
                    selected={current}
                    onChange={(pageNumber: number) => {
                        const newSearch = qs.stringify({ ...search, page: pageNumber });
                        logEvent(AnalyticsEvent.EVTNM_CLICKED_PAGINATION_CONTROL, {
                            Value: pageNumber,
                            Type: 'Number',
                            'SRP Version': 2,
                        });
                        history.push({
                            search: newSearch.toLowerCase(),
                            state: { normalization: true },
                        });
                        window.scrollTo(0, 100);
                        document
                            .querySelector('.index--mapVenueListOverflowWrapper #stickyBoundary [data-layout="col"]:nth-child(2)')
                            ?.scrollTo(0, 0);
                    }}
                />
            </div>
        );
    }
    return <></>;
};
